export default {
  "settings": "Настройки",
  "settings.profile": "Профиль",
  "settings.team": "Команда",
  "settings.notifications": "Уведомления",
}
